"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gen_test = exports.gen = void 0;
var randoInstanced_sidecar_1 = require("@dive/to-engine/randoInstanced-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var battlescapeMap_sidecar_1 = require("./battlescapeMap-sidecar");
var battlescapeProtoSectionsLoader_sidecar_1 = require("./battlescapeProtoSectionsLoader-sidecar");
var minigolfDefs_sidecar_1 = require("../defs/minigolfDefs-sidecar");
var minigolfCreatures_sidecar_1 = require("../entities/minigolfCreatures-sidecar");
var minigolfGameState_sidecar_1 = require("../simulation/minigolfGameState-sidecar");
var minigolfMainGameGenerator_sidecar_1 = require("../simulation/minigolfMainGameGenerator-sidecar");
var minigolfGen_addCreatures_sidecar_1 = require("./minigolfGen_addCreatures-sidecar");
var minigolfRegions_sidecar_1 = require("./minigolfRegions-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var minigolfFloatingTexts_sidecar_1 = require("../entities/minigolfFloatingTexts-sidecar");
var namespace = 'battlescape-generator';
var gen = function (m) {
    var seed = 'brenden2';
};
exports.gen = gen;
var _protoSections = [];
function gen_test(m) {
    var rando, host, path, file, baseUrl, url, text, res, idxAttempt, maxAttempts, isReset, _loop_1, state_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                rando = randoInstanced_sidecar_1.randoInstanced.createRando(Date.now());
                if (_protoSections.length === 0) {
                    host = window.location.host;
                    path = '/assets/data/';
                    file = 'minigolf-regions.txt';
                    baseUrl = window.location.protocol + '//' + host + path;
                    url = baseUrl + file //'ufo-sections-proto.pix'
                    ;
                    text = common_sidecar_1.common.getPhaserScene().cache.text.get('minigolf-regions');
                    console.log('text is', text);
                    console.log('text is', common_sidecar_1.common.getPhaserScene().cache.text.getKeys());
                    console.log('url is', url);
                    res = text;
                    _protoSections = battlescapeProtoSectionsLoader_sidecar_1.battlescapeProtoSectionsLoader.loadSectionPrototypes(res);
                    // Convert to minigolf regions w/ rotation
                    minigolfRegions_sidecar_1.minigolfRegions.loadMinigolfRegions(_protoSections);
                }
                idxAttempt = 0;
                maxAttempts = 10000;
                isReset = true;
                _loop_1 = function () {
                    var openSections, lengthLeft, sectionX, sectionY, needsStart, cameFromExit, ps, playerState, isWinLevel, basePar, copySection, exitOffset, getOppositeExit, moveByExit, diff, isEasy, isNormal, isHard, startRegions, isTest, mainRegions, deadEndRegions, outsideRegions, endRegions, difficultySelectRegions, winRegions, section, possibleRegions, region, _loop_2, i, i, section, region;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                idxAttempt++;
                                isReset = false;
                                minigolfCreatures_sidecar_1.minigolfCreatures.killAll();
                                minigolfFloatingTexts_sidecar_1.minigolfFloatingTexts.killAll();
                                battlescapeMap_sidecar_1.battlescapeMap.clear(m);
                                openSections = [];
                                lengthLeft = 5 // debugging
                                ;
                                sectionX = 1;
                                sectionY = 1;
                                needsStart = true;
                                cameFromExit = minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.None;
                                ps = minigolfGameState_sidecar_1.minigolfGameState.get().playerState;
                                if (ps.dungeonLevel === 0) {
                                    lengthLeft = 2;
                                }
                                if (ps.dungeonLevel === 1) {
                                    lengthLeft = 3;
                                }
                                if (ps.dungeonLevel === 2) {
                                    lengthLeft = 4;
                                }
                                if (ps.dungeonLevel === 3) {
                                    lengthLeft = 5;
                                }
                                if (ps.dungeonLevel >= 4) {
                                    lengthLeft = rando.sample([4, 5, 6, 7, 8, 9]);
                                }
                                playerState = minigolfGameState_sidecar_1.minigolfGameState.get().playerState;
                                isWinLevel = playerState.dungeonLevel >= 19;
                                if (isWinLevel) {
                                    lengthLeft = 1;
                                }
                                basePar = 3;
                                // if (lengthLeft > 3) {
                                //   basePar++
                                // }
                                if (lengthLeft > 5) {
                                    basePar++;
                                }
                                if (lengthLeft > 7) {
                                    basePar++;
                                }
                                // if (lengthLeft > 8) {
                                //   basePar++
                                // }
                                ps.levelPar = basePar;
                                copySection = function (protoSection, section, secX, secY, isOutside) {
                                    if (isOutside === void 0) { isOutside = false; }
                                    // let protoSection = protoSections[2]
                                    var size = battlescapeMap_sidecar_1.battlescapeMap.sectionSize;
                                    assert_sidecar_1.assert.notNil(section);
                                    // Get our section
                                    var sectionDest = battlescapeMap_sidecar_1.battlescapeMap.getSectionAt(m, secX, secY);
                                    if (!sectionDest) {
                                        console.warn('no section dest', secX, secY);
                                        minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.signal_newLevel();
                                        return false;
                                    }
                                    if (sectionDest.isFilled) {
                                        console.warn('section dest already filled', secX, secY);
                                        minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.signal_newLevel();
                                        return false;
                                    }
                                    sectionDest.isFilled = true;
                                    if (protoSection.tileWidth === size && protoSection.tileHeight === size) {
                                        console.log(namespace, protoSection.name, secX, secY);
                                        // console.log('trying to copy', protoSection)
                                        for (var j = 0; j < protoSection.tileHeight; j++) {
                                            for (var i = 0; i < protoSection.tileWidth; i++) {
                                                var tDest = battlescapeMap_sidecar_1.battlescapeMap.getAt(m, section.otx + i, section.oty + j);
                                                assert_sidecar_1.assert.notNil(tDest, 'no dest');
                                                var tSrc = protoSection.tiles[j * protoSection.tileWidth + i];
                                                assert_sidecar_1.assert.notNil(tSrc, 'no src');
                                                tDest.color = tSrc.color;
                                                tDest.rotation = tSrc.rotation;
                                                if (!isOutside) {
                                                    tDest.tileIdx = tSrc.tileIdx;
                                                    tDest.tileIdxUp = tSrc.tileIdxUp;
                                                }
                                                else {
                                                    tDest.tileIdx = tSrc.tileIdx;
                                                    tDest.tileIdxUp = tSrc.tileIdxUp;
                                                    if (tDest.tileIdx === 0) {
                                                        tDest.tileIdx = -1; // Outside color adjust
                                                    }
                                                }
                                                // yield 0
                                                // tDest.color = diveColors.orange
                                            }
                                        }
                                        //let t = battlescapeMap.getAt(m, idxSectionX, idxSectionY)
                                        //assert.notNil(t)
                                        //t.tileIdx = 1
                                        return true;
                                    }
                                    else {
                                        return false;
                                    }
                                };
                                exitOffset = function (exit) {
                                    if (exit === minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.North) {
                                        return { x: 0, y: -1 };
                                    }
                                    if (exit === minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.East) {
                                        return { x: 1, y: 0 };
                                    }
                                    if (exit === minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.South) {
                                        return { x: 0, y: 1 };
                                    }
                                    if (exit === minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.West) {
                                        return { x: -1, y: 0 };
                                    }
                                    return { x: 0, y: 0 };
                                };
                                getOppositeExit = function (exit) {
                                    if (exit === minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.North) {
                                        return minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.South;
                                    }
                                    if (exit === minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.East) {
                                        return minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.West;
                                    }
                                    if (exit === minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.South) {
                                        return minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.North;
                                    }
                                    if (exit === minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.West) {
                                        return minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.East;
                                    }
                                    return minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.None;
                                };
                                moveByExit = function (exit, ignoreExit) {
                                    // console.log(namespace, 'moveByExit', exit, ignoreExit)
                                    exit &= ~ignoreExit; // Remove ignoreExit
                                    // Randomly pick an available exit
                                    var possibleExits = [];
                                    if (exit & minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.North) {
                                        possibleExits.push(minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.North);
                                    }
                                    if (exit & minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.East) {
                                        possibleExits.push(minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.East);
                                    }
                                    if (exit & minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.South) {
                                        possibleExits.push(minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.South);
                                    }
                                    if (exit & minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.West) {
                                        possibleExits.push(minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.West);
                                    }
                                    if (possibleExits.length === 0) {
                                        console.warn(namespace, 'no possible exits', exit, ignoreExit);
                                        return false;
                                    }
                                    exit = rando.sampleAndRemove(possibleExits);
                                    // const addPossibleExits = (exitChosen: number, avoid) => {
                                    // }
                                    if (possibleExits.length > 0) {
                                        for (var i = 0; i < possibleExits.length; i++) {
                                            var notUsedExit = possibleExits[i];
                                            var fromNotUsedExit = getOppositeExit(notUsedExit);
                                            var xo = exitOffset(notUsedExit);
                                            var section = battlescapeMap_sidecar_1.battlescapeMap.getSectionAt(m, sectionX + xo.x, sectionY + xo.y);
                                            if (section) {
                                                openSections.push({
                                                    section: section,
                                                    fromExit: fromNotUsedExit,
                                                });
                                            }
                                        }
                                    }
                                    // console.log(namespace, 'moveByExit2', exit, ignoreExit)
                                    if (exit & minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.North) {
                                        sectionY--;
                                        cameFromExit = minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.South;
                                        return true;
                                        // console.log(namespace, 'moveByExit3', 'north')
                                    }
                                    if (exit & minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.East) {
                                        sectionX++;
                                        cameFromExit = minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.West;
                                        return true;
                                        //  console.log(namespace, 'moveByExit3', 'east')
                                    }
                                    if (exit & minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.South) {
                                        sectionY++;
                                        cameFromExit = minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.North;
                                        return true;
                                        // console.log(namespace, 'moveByExit3', 'south')
                                    }
                                    if (exit & minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.West) {
                                        sectionX--;
                                        cameFromExit = minigolfRegions_sidecar_1.minigolfRegions.MinigolfExitFlags.East;
                                        return true;
                                        //  console.log(namespace, 'moveByExit3', 'west')
                                    }
                                    console.warn(namespace, 'no exit', exit, ignoreExit);
                                    minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.signal_newLevel();
                                    //assert.failed('no exit')
                                    return false;
                                };
                                diff = minigolfGameState_sidecar_1.minigolfGameState.get().playerState.dungeonLevel;
                                isEasy = playerState.difficulty === 'easy';
                                isNormal = playerState.difficulty === 'normal';
                                isHard = playerState.difficulty === 'hard';
                                if (isEasy) {
                                    if (diff > 2) {
                                        diff -= 1;
                                    }
                                    if (diff > 5) {
                                        diff -= 1;
                                    }
                                    if (diff > 8) {
                                        diff -= 1;
                                    }
                                }
                                if (isHard) {
                                    diff += 3;
                                }
                                startRegions = minigolfRegions_sidecar_1.minigolfRegions.allMinigolfRegions.filter(function (r) { return r.isStart && r.enemyDifficulty <= diff; });
                                isTest = minigolfDefs_sidecar_1.minigolfDefs.debug_useTestRegion;
                                if (isTest) {
                                    diff = 999;
                                }
                                mainRegions = minigolfRegions_sidecar_1.minigolfRegions.allMinigolfRegions.filter(function (r) {
                                    return !r.isStart &&
                                        !r.isEnd &&
                                        !r.isDeadEnd &&
                                        !r.isOutside &&
                                        !r.isDifficultySelect &&
                                        !r.isWinLevel &&
                                        r.isTest === isTest &&
                                        r.enemyDifficulty <= diff;
                                });
                                deadEndRegions = minigolfRegions_sidecar_1.minigolfRegions.allMinigolfRegions.filter(function (r) { return r.isDeadEnd && r.enemyDifficulty <= diff; });
                                outsideRegions = minigolfRegions_sidecar_1.minigolfRegions.allMinigolfRegions.filter(function (r) { return r.isOutside && r.enemyDifficulty <= diff; });
                                endRegions = minigolfRegions_sidecar_1.minigolfRegions.allMinigolfRegions.filter(function (r) { return r.isEnd && r.enemyDifficulty <= diff; });
                                difficultySelectRegions = minigolfRegions_sidecar_1.minigolfRegions.allMinigolfRegions.filter(function (r) { return r.isDifficultySelect && r.enemyDifficulty <= diff; });
                                winRegions = minigolfRegions_sidecar_1.minigolfRegions.allMinigolfRegions.filter(function (r) { return r.isWinLevel; });
                                _b.label = 1;
                            case 1:
                                if (!(lengthLeft > 0)) return [3 /*break*/, 3];
                                if (isReset) {
                                    return [3 /*break*/, 3];
                                }
                                section = battlescapeMap_sidecar_1.battlescapeMap.getSectionAt(m, sectionX, sectionY);
                                if (!section) {
                                    console.log(namespace, 'hit map end!');
                                    isReset = true;
                                    minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.signal_newLevel();
                                    return [3 /*break*/, 3];
                                }
                                assert_sidecar_1.assert.notNil(section);
                                // if (needsStart) {
                                //   console.log(namespace, 'finding start')
                                //   let startRegion = rando.sample(startRegions)
                                //   console.log(
                                //     namespace,
                                //     'startRegion',
                                //     startRegion.name,
                                //     startRegion.exitFlags,
                                //   )
                                //   if (
                                //     !copySection(startRegion.protoSection, section, sectionX, sectionY)
                                //   ) {
                                //     isReset = true
                                //     break
                                //   }
                                //   if (!moveByExit(startRegion.exitFlags, cameFromExit)) {
                                //     isReset = true
                                //     break
                                //   }
                                //   needsStart = false
                                //   lengthLeft--
                                //   continue
                                // }
                                console.log(namespace, 'finding section');
                                possibleRegions = mainRegions;
                                if (needsStart) {
                                    possibleRegions = startRegions;
                                    if (isWinLevel) {
                                        possibleRegions = winRegions;
                                    }
                                }
                                // Last section, only allow end sections
                                if (lengthLeft === 1) {
                                    if (isWinLevel) {
                                        possibleRegions = winRegions;
                                    }
                                    else {
                                        console.log(namespace, 'finding end');
                                        if (playerState.dungeonLevel === 0) {
                                            possibleRegions = difficultySelectRegions;
                                        }
                                        else {
                                            possibleRegions = endRegions;
                                        }
                                    }
                                }
                                // Filter by fits previous piece
                                if (!needsStart) {
                                    possibleRegions = possibleRegions.filter(function (r) { return r.exitFlags & cameFromExit; });
                                }
                                if (possibleRegions.length === 0) {
                                    console.log(namespace, 'no possible regions');
                                    isReset = true;
                                    minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.signal_newLevel();
                                    //return 0
                                    return [3 /*break*/, 3];
                                }
                                region = rando.sample(possibleRegions);
                                copySection(region.protoSection, section, sectionX, sectionY);
                                moveByExit(region.exitFlags, cameFromExit);
                                lengthLeft--;
                                needsStart = false;
                                if (lengthLeft === 0) {
                                    // Success!
                                    return [3 /*break*/, 3];
                                }
                                return [4 /*yield*/, 0];
                            case 2:
                                _b.sent();
                                return [3 /*break*/, 1];
                            case 3:
                                // Fill possible exits
                                if (minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.get().signal_newLevel) {
                                    isReset = true;
                                    return [2 /*return*/, "break"];
                                    //return 0
                                }
                                _loop_2 = function (i) {
                                    var openSection, validRegions, region;
                                    return __generator(this, function (_c) {
                                        switch (_c.label) {
                                            case 0:
                                                openSection = openSections[i];
                                                console.log(namespace, 'open section', openSection);
                                                if (!openSection.section.isFilled) {
                                                    validRegions = deadEndRegions.filter(function (c) { return c.exitFlags & openSection.fromExit; });
                                                    if (validRegions.length > 0) {
                                                        region = rando.sample(validRegions);
                                                        copySection(region.protoSection, openSection.section, openSection.section.secx, openSection.section.secy, false);
                                                    }
                                                }
                                                else {
                                                    console.log(namespace, 'open section already filled!', openSection);
                                                }
                                                return [4 /*yield*/, 0];
                                            case 1:
                                                _c.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                };
                                i = 0;
                                _b.label = 4;
                            case 4:
                                if (!(i < openSections.length)) return [3 /*break*/, 7];
                                return [5 /*yield**/, _loop_2(i)];
                            case 5:
                                _b.sent();
                                _b.label = 6;
                            case 6:
                                i++;
                                return [3 /*break*/, 4];
                            case 7:
                                i = 0;
                                _b.label = 8;
                            case 8:
                                if (!(i < m.sections.length)) return [3 /*break*/, 11];
                                section = m.sections[i];
                                if (!section.isFilled) {
                                    region = rando.sample(outsideRegions);
                                    copySection(region.protoSection, section, section.secx, section.secy, true);
                                }
                                if (!!minigolfDefs_sidecar_1.minigolfDefs.debug_fasterLevelGen) return [3 /*break*/, 10];
                                return [4 /*yield*/, 0];
                            case 9:
                                _b.sent();
                                _b.label = 10;
                            case 10:
                                i++;
                                return [3 /*break*/, 8];
                            case 11: return [5 /*yield**/, __values(minigolfGen_addCreatures_sidecar_1.minigolfGen_addCreatures.gen_addCreatures(m, rando))];
                            case 12:
                                _b.sent();
                                if (!isReset) {
                                    return [2 /*return*/, { value: 1 }];
                                }
                                return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!(idxAttempt < maxAttempts)) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_1()];
            case 2:
                state_1 = _a.sent();
                if (typeof state_1 === "object")
                    return [2 /*return*/, state_1.value];
                if (state_1 === "break")
                    return [3 /*break*/, 3];
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
}
exports.gen_test = gen_test;
